import api from "../../service";
import middleware from "../../middleware";

class StudentMetaService extends middleware {
	constructor() {
		super();
		this.url = `${api.defaults.baseURL}/studentMeta`;
	}

    async getAll() {
        const response = await api.get(`${this.url}`, {
            params: {
                db_name: this.db_name,
                user_id: this.user_id,
                user_token: this.user_token,
            }
        })
        return response.data
    }

    async getBox(id) {
        const response = await api.get(`${this.url}/box/${id}`, {
            params: {
                db_name: this.db_name,
                user_id: this.user_id,
                user_token: this.user_token,
            }
        })
        return response.data
    }

    async getBoxData(box, id = 0) {
        const response = await api.get(`${this.url}/${id}`, {
            params: {
                db_name: this.db_name,
                user_id: this.user_id,
                user_token: this.user_token,
				box: box
            }
        })
        return response.data
    }

	async setMeta(key, data) {
		try {
			const response = await api.put(`${this.url}/setMeta`, data, {
				params: {
					db_name: this.db_name,
					user_id: this.user_id,
					user_token: this.user_token,
					key: key
				}
			})
			return response
		} catch (error) {
			console.log(error)
		}
	}
}

export default StudentMetaService
